import {
  ReportingImportRow,
  ReportingImportRowPayload,
} from '../reporting/reporting-import.model';
import {
  CarrierProductionRawCarrierFileProcessingStatus,
} from '../reporting/carrier-production-raw-carrier-file.model';
import { ReportingImportRunStatus } from '../reporting/reporting-import.model';

export enum MutateReportingImportInvalidRowRequestKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
  rowNumber = 'rowNumber',
  correctedPayload = 'correctedPayload',
}

export interface MutateReportingImportInvalidRowRequest {
  [MutateReportingImportInvalidRowRequestKeys.runId]?: string | null;
  [MutateReportingImportInvalidRowRequestKeys.uploadActionId]?: string | null;
  [MutateReportingImportInvalidRowRequestKeys.rowNumber]: number;
  [MutateReportingImportInvalidRowRequestKeys.correctedPayload]: ReportingImportRowPayload;
}

export interface MutateReportingImportInvalidRowResponse {
  row: ReportingImportRow;
  recordsTotal: number;
  recordsValid: number;
  recordsInvalid: number;
  recordsResolved: number;
  runStatus: ReportingImportRunStatus;
  rawFileStatus: CarrierProductionRawCarrierFileProcessingStatus;
}
